export default "__VITE_ASSET__BGWs66il__"